module.exports = __webpack_public_path__ + "static/media/MY-UOSM.413c07bd.png";